export const POSITIONS = {
  top: {
    inactive: {
      x1: 0,
      y1: 5,
      x2: 33,
      y2: 5
    },
    active: {
      x1: 2,
      y1: 16.5,
      x2: 15,
      y2: 16.5 - 11
    }
  },
  middle: {
    inactive: {
      x1: 0,
      y1: 16.5,
      x2: 33,
      y2: 16.5
    },
    active: {
      x1: 0,
      y1: 16.5,
      x2: 31,
      y2: 16.5
    }
  },
  bottom: {
    inactive: {
      x1: 0,
      y1: 28,
      x2: 33,
      y2: 28
    },
    active: {
      x1: 2,
      y1: 16.5,
      x2: 15,
      y2: 16.5 + 11
    }
  }
}

export default POSITIONS
